import { useState } from 'react';

/**
 * Modal genérico de selección con buscador (HU-027) — se usa para elegir
 * distrito y para filtrar por categoría, en vez de las filas de chips que
 * quedaban largas y difíciles de recorrer en el mapa.
 */
const ModalSeleccion = ({ titulo, placeholder, opciones, activoId, onSeleccionar, onCerrar }) => {
  const [q, setQ] = useState('');
  const termino = q.trim().toLowerCase();
  const filtradas = termino
    ? opciones.filter((o) => (o.label || '').toLowerCase().includes(termino))
    : opciones;

  return (
    <div className="mp-modal-fondo" onClick={onCerrar}>
      <div className="mp-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={titulo}>
        <div className="mp-modal-cabecera">
          <h3>{titulo}</h3>
          <button type="button" className="mp-modal-cerrar" onClick={onCerrar} aria-label="Cerrar">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <input
          type="text"
          className="mp-modal-buscar"
          placeholder={placeholder}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          autoFocus
        />

        <div className="mp-modal-lista">
          {filtradas.length === 0 && <p className="mp-modal-vacio">Sin resultados.</p>}
          {filtradas.map((o) => (
            <button
              key={o.id}
              type="button"
              className={`mp-modal-opcion${o.id === activoId ? ' activo' : ''}`}
              onClick={() => onSeleccionar(o.id)}
            >
              {o.color && <span className="mp-modal-color" style={{ background: o.color }} />}
              <span className="mp-modal-opcion-texto">{o.label}</span>
              {o.id === activoId && <i className="fas fa-check"></i>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalSeleccion;
